module.exports = __webpack_public_path__ + "img/integration6.938624f3.jpeg";